/**
 * Harvest Monitoring (Kemandoran) Page
 * Main page component for the per-foreman-group monitoring report.
 */

import React, { useEffect } from 'react';
import {
    Box,
    HStack,
    Heading,
    Text,
    VStack,
    useToast,
} from '@chakra-ui/react';
import Navbar from '../../../components/Navbar';
import { FilterHarvestMonitoring } from '../../harvest/components/FilterHarvestMonitoring';
import { HarvestForemanTable } from '../components/HarvestForemanTable';
import { useHarvestMonitoringForeman } from '../hooks/useHarvestMonitoringForeman';
import type { HarvestMonitoringFilters } from '../types';

export const HarvestMonitoringForemanPage: React.FC = () => {
    const { data, loading, error, fetchData } = useHarvestMonitoringForeman();
    const toast = useToast();

    // Fetch data on initial load
    useEffect(() => {
        fetchData();
    }, []);

    // Show error toast when error occurs
    useEffect(() => {
        if (error) {
            toast({
                title: 'Error',
                description: error,
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'top-right',
            });
        }
    }, [error, toast]);

    const handleFiltersChange = (filters: HarvestMonitoringFilters) => {
        fetchData(filters);
    };

    return (
        <Box minH="100vh" bg="gray.50">
            <Navbar />

            <Box flex="1" p={{ base: 4, md: 6 }}>
                <VStack spacing={6} align="stretch">
                    <VStack align="start" spacing={1}>
                        <Heading size="lg" color="gray.700" mb={2}>
                            Hasil Panen per Kemandoran
                        </Heading>
                        <HStack spacing={4} flexWrap="wrap">
                            <Text color="gray.600" fontSize="sm">
                                Hasil panen per kemandoran untuk penginputan hasil panen ODOO oleh Kerani Divisi.
                            </Text>
                        </HStack>
                    </VStack>

                    <FilterHarvestMonitoring
                        onFiltersChange={handleFiltersChange}
                        isLoading={loading}
                    />

                    <HarvestForemanTable
                        data={data}
                        loading={loading}
                        error={error}
                    />
                </VStack>
            </Box>
        </Box>
    );
};
